import React from "react";
import { Flex, Text, Box, Stack } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

interface NoteCardProps {
  title: string;
  description: string;
  color: string;
  bgColor: string;
}

const NoteCard: React.FC<NoteCardProps> = ({
  title,
  description,
  color,
  bgColor,
}) => {
  return (
    <Box
      flex="1"
      bg={bgColor} // light bg of the color
      borderLeft={`6px solid ${color}`} // thick left border
      p={4}
      // boxShadow={`0px 6px 16px -4px ${color}`} // bottom shadow tint
      minH="130px"
    >
      <Text fontSize="20px" fontWeight="600" mb={2}>
        {title}
      </Text>
      <Text fontSize="16px" color="gray.700" fontWeight="400">
        {description}
      </Text>
    </Box>
  );
};

const AiNotes: React.FC = () => {
  const { t } = useTranslation("common");

  const notes = [
    {
      title: "Critical",
      description:
        "Critical hazard detected at 12:00 PM on 1st October 2025 at site 1 with 100% probability of occurrence of fire with 100% probability of occurrence of explosion",
      color: "#DE7F04",
      bgColor: "#DE7F040A",
    },
    {
      title: "Info",
      description:
        "Info hazard detected at 12:00 PM on 1st October 2025 at site 1 with 50% probability of occurrence of fire with 100% probability of occurrence of explosion",
      color: "#3AB65A",
      bgColor: "#3AB65A0A",
    },
    {
      title: "Weather Alert",
      description:
        "Weather alert detected at 12:00 PM on 1st October 2025 at site 1 with 100% probability of occurrence of heavy rain with 100km/h speed with 100% probability of occurrence of flood",
      color: "#DC3545",
      bgColor: "#DC35450A",
    },
  ];

  return (
    <Flex
      direction="column"
      border="1px solid #E0E0E0"
      borderRadius="16px"
      p="24px"
      gap={6}
    >
      <Text fontSize="24px" fontWeight="bold" color="black">
        {t("aiNotes.title")}
      </Text>

      <Flex
        gap={6}
        flexWrap={{ base: "wrap", md: "nowrap" }}
        direction="column"
      >
        {notes?.map((note, idx) => (
          <NoteCard key={idx} {...note} />
        ))}
      </Flex>
    </Flex>
  );
};

export default AiNotes;
